
import { mixins } from "vue-class-component";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class EmptyGrid extends Vue {
  @Prop({ default: "" }) readonly title!: string;
}
